import React, { Component, Fragment } from 'react';
import { shallowEqual } from 'recompose';
import MarkerClusterer from 'react-google-maps/lib/components/addons/MarkerClusterer';

import {
  CLUSTER_STYLES,
  CLUSTER_GRID_SIZE,
  ZOOM_LEVELS,
  SYMBOL_TYPES
} from 'shared/constants/map';
import { getSymbolUrl } from 'shared/helpers/map';
import MapShopMarker from './MapShopMarker';

export default class MapShopMarkers extends Component {
  renderMarker = shop => {
    const {
      onMarkerClick: handleMarkerClick,
      onInfoWindowClose: handleInfoWindowClose,
      handleDirections,
      t
    } = this.props;

    return (
      <MapShopMarker
        key={`Shops_Map_Marker_${shop.id}`}
        shop={shop}
        onMarkerClick={handleMarkerClick}
        onInfoWindowClose={handleInfoWindowClose}
        handleDirections={handleDirections}
        t={t}
      />
    );
  };

  shouldComponentUpdate(nextProps) {
    if (this.props.selectedShopId !== nextProps.selectedShopId) {
      /*
        The map zoom and the selectedShopId prop updates were conflicting, preventing the clusters to be recomputed.
        The setTimeout bellow aims to delay the clusters rerender according to the selectedShopId prop.
        This allow the "clusterization" to occur twice:
          It is triggered at first be the zoom update.
          Then it is triggered by the selectedShopId prop update.
       */
      setTimeout(() => this.forceUpdate(), 0);
      return false;
    }
    return !shallowEqual(this.props, nextProps);
  }

  renderSelectedMarker = shop => {
    const {
      onMarkerClick: handleMarkerClick,
      onInfoWindowClose: handleInfoWindowClose,
      handleDirections,
      directionsPending,
      isSelectedShopLoading,
      t
    } = this.props;

    return (
      <MapShopMarker
        key={`Shops_Map_Marker_${shop.id}`}
        shop={shop}
        onMarkerClick={handleMarkerClick}
        onInfoWindowClose={handleInfoWindowClose}
        handleDirections={handleDirections}
        directionsPending={directionsPending}
        isLoading={isSelectedShopLoading}
        t={t}
        isSelected
      />
    );
  };

  render() {
    const { renderMarker, renderSelectedMarker } = this;
    const { shops, selectedShopId } = this.props;

    return (
      <Fragment>
        {shops
          .filter(shop => selectedShopId === shop.id)
          .map(renderSelectedMarker)}
        <MarkerClusterer
          styles={[
            {
              ...CLUSTER_STYLES,
              url: getSymbolUrl(SYMBOL_TYPES.CLUSTER)
            }
          ]}
          maxZoom={ZOOM_LEVELS.CLUSTER_MAX}
          gridSize={CLUSTER_GRID_SIZE}
          averageCenter
        >
          {shops.filter(shop => selectedShopId !== shop.id).map(renderMarker)}
        </MarkerClusterer>
      </Fragment>
    );
  }
}
